export interface IWindow {
    // 跳转类型
    type?: IWindowType;
    // 跳转路径
    url?: string;
    // 跳转appID
    applicationId?: string;
    // 是否可分享
    shareFlag?: boolean;
    // 下一个窗口返回上一个窗口是否调用监听
    nBack?: boolean;
    // 接口调用成功的回调函数
    success?: (data: any) => void;
    // 接口调用失败的回调函数
    fail?: (error: any) => void;
    // 接口调用结束的回调函数（调用成功、失败都会执行）
    complete?: (msg: any) => void;
    // 跳转监听
    // 如果nBack为True调用
    listener?: () => void;
}

export enum IWindowType {
    NATIVE = 'native',
    URL = 'url'
}
